import React from 'react';
import { Dialog } from 'primereact/dialog';
import { Button } from 'primereact/button';
import { PrimeIcons } from 'primereact/api';
import { classNames } from 'primereact/utils';

interface Props {
  visible: boolean;
  onHide: () => void;
  onConfirm: () => void;
  isSaving: boolean;
}

export const UnblockSlotDialog = ({ visible, onHide, onConfirm, isSaving }: Props) => (
  <Dialog
    header='Desbloquear horario'
    visible={visible}
    onHide={onHide}
    className='cancellation-dialog big-modal'
    draggable={false}
    resizable={false}
    dismissableMask
    footer={
      <div className='dialog-footer'>
        <Button label='Volver' icon='pi pi-times' onClick={onHide} className='p-button-text' disabled={isSaving} />
        <Button
          label='Confirmar desbloqueo'
          icon='pi pi-check'
          onClick={onConfirm}
          className='p-button-primary'
          autoFocus
          loading={isSaving}
        />
      </div>
    }
  >
    <div className='cancellation-info warning'>
      <i className={classNames(PrimeIcons.UNLOCK, 'warning-icon')} />
      <p className='warning-title'>Esta acción desbloqueará el horario seleccionado.</p>
      <p>Esto permitirá que los clientes puedan realizar reservas en este horario.</p>
    </div>
  </Dialog>
);
